module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/instagram.5572f9e0.svg";